var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{class:_vm.containerStyles,attrs:{"column":""}},[(_vm.title)?_c('v-flex',{class:_vm.titleStyles},[_c('v-subheader',[_vm._v(_vm._s(_vm.title))])],1):_vm._e(),(_vm.title)?_c('v-divider'):_vm._e(),_c('v-flex',{class:_vm.contentStyles},[_vm._t("default")],2),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }